module.exports = __webpack_public_path__ + "img/games-6.5021dd7d.jpg";